import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FiImage } from "react-icons/fi";
import { CATEGORIES } from "../constants";

const MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    ["link"],
    ["clean"],
  ],
};

const FORMATS = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "code-block",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];

const PostForm = ({
  title,
  setTitle,
  category,
  setCategory,
  description,
  setDescription,
  thumbnail,
  setThumbnail,
  error,
  onSubmit,
  submitLabel,
  onCancel,
}) => (
  <form className="form" onSubmit={onSubmit}>
    {error && <p className="alert">{error}</p>}

    <div className="field">
      <label className="field__label" htmlFor="post-title">
        Title
      </label>
      <input
        id="post-title"
        className="input input--lg"
        type="text"
        placeholder="How we cut p99 latency in half"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        autoFocus
      />
    </div>

    <div className="field-row">
      <div className="field">
        <label className="field__label" htmlFor="post-category">
          Category
        </label>
        <select
          id="post-category"
          className="select"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          {CATEGORIES.map((cat) => (
            <option key={cat}>{cat}</option>
          ))}
        </select>
      </div>

      <div className="field">
        <span className="field__label">Cover image</span>
        <label className="dropzone">
          <FiImage />
          <span>
            <strong>{thumbnail?.name || "Choose an image"}</strong>
            <span>PNG or JPG</span>
          </span>
          <input
            type="file"
            accept="image/png, image/jpg, image/jpeg"
            onChange={(e) => setThumbnail(e.target.files[0])}
          />
        </label>
      </div>
    </div>

    <div className="field">
      <span className="field__label">Content</span>
      <div className="editor">
        <ReactQuill
          modules={MODULES}
          formats={FORMATS}
          value={description}
          onChange={setDescription}
          placeholder="Write something worth reading…"
        />
      </div>
    </div>

    <div className="form-actions">
      {onCancel && (
        <button type="button" className="btn btn--ghost" onClick={onCancel}>
          Cancel
        </button>
      )}
      <button type="submit" className="btn btn--primary">
        {submitLabel}
      </button>
    </div>
  </form>
);

export default PostForm;
